import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { USER_TYPE, USER_TYPES } from '@/constants/constants';

export const useUserType = create(
  persist(
    set => ({
      userType: USER_TYPE, // Default from .env (therapist or patient)

      // Set user type (used during login/signup)
      setUserType: type =>
        set({
          userType: type,
        }),

      // Get contact form route type
      getContactFormUserType: () => {
        const state = useUserType.getState();
        if (state.userType === USER_TYPES.PATIENT) {
          return USER_TYPES.PATIENT;
        }
        if (state.userType === USER_TYPES.DASHBOARD) {
          return USER_TYPES.DASHBOARD;
        }
        return USER_TYPES.THERAPIST;
      },

      // Reset to default
      resetUserType: () =>
        set({
          userType: USER_TYPE,
        }),
    }),
    {
      name: 'rehab-user-type', // name in localStorage
      storage: createJSONStorage(() => localStorage),
    }
  )
);
